import { useDispatch, useSelector } from "react-redux";
import cancel_img from '../../assets/images/cancel.svg'

import { selectTranslations } from "../../services/i18n/i18nSlice";
import { selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { selectAppAuth } from "../../services/auth/authSlice";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";


import Text from "../../components/Text";
import TitleH1 from "../../components/TitleH1";
import { loadUserProfileData, selectUserFields, selectUserInfo } from "../../features/User/userSlice";

import ok_img from './Onboarding/images/answer.svg'
import Spinner from 'react-bootstrap/Spinner';


import './LoginScreen.css'



export default function AdminWaitingScreen () {

    const personalizations = useSelector(selectAppPersonalizations)
    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(()=>{
        setInterval(()=>{
            dispatch(loadUserProfileData())
        }, 60000)
    },[])
    
    useEffect(()=>{
        if(userInfo?.user_data?.state === "active"){
            setTimeout(()=>{
                navigate('/login/onboarding', {replace:true})
            }, 5000)
        }
    },[userInfo])

    return(
        <div id="waitingScreen">
            {userInfo?.user_data?.state === "waiting_admin_check" ?
                <div className="fh-div d-flex flex-column align-items-center justify-content-between fade-in-animation">
                    <div className="top">
                        <img src={personalizations?.logo_url} className="mx-auto d-block" />
                        <TitleH1 className="text-center mt-2 loading_text">{t.login.waiting_admin}</TitleH1>
                        <Text className="text-center mt-2">{t.login.waiting_admin_text}</Text>
                        <div className="d-flex justify-content-center">
                            <Spinner />
                        </div>
                    </div>
                </div>
            :
                <div className="fh-div d-flex flex-column align-items-center justify-content-between fade-in-animation">
                    <div className="top">
                        <img src={personalizations?.logo_url} className="mx-auto d-block" />
                        <img src={ok_img} className="mx-auto mt-4 d-block" />
                        <TitleH1 className="text-center mt-3 loading_text">{t.login.email_verified}</TitleH1>
                        <Text className="text-center mt-2">{t.login.email_verified_text}</Text>
                    </div>
                </div>
            }
        </div>
    )
}